import mileageReportComponent from './mileage_report.component';

let mileageReportModule = angular.module('mileageReport', [])
    .component('mileageReportComponent', mileageReportComponent)
    .name;

export default mileageReportModule;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/mileage_report/index.js